// @ts-nocheck
/* eslint-disable */
/* tslint:disable */
/* prettier-ignore-start */
/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */
// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: ct9kVdatV78GHhK9QiJ54N
// Component: JUc6WlNS_gQ
import * as React from "react";
import * as p from "@plasmicapp/react-web";
import * as ph from "@plasmicapp/react-web/lib/host";
import {
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts
} from "@plasmicapp/react-web";
import Sidebar from "../../Sidebar"; // plasmic-import: KsLZ7sb8Ji8/component
import FinancialDetails from "../../FinancialDetails"; // plasmic-import: JeHEC7IaZdN-/component
import UserManagement from "../../UserManagement"; // plasmic-import: rrcLeJ0HKJ8b/component
import Branding from "../../Branding"; // plasmic-import: K8v3dumcNAbx/component
import Checkbox3 from "../../Checkbox3"; // plasmic-import: YObM5SxsQhe/component
import InviteUserCard from "../../InviteUserCard"; // plasmic-import: gaBhAtYjsa/component
import Button from "../../Button"; // plasmic-import: qD6dz0yVMKR/component
import "@plasmicapp/react-web/lib/plasmic.css";
import plasmic_antd_5_hostless_css from "../antd_5_hostless/plasmic_antd_5_hostless.module.css"; // plasmic-import: ohDidvG9XsCeFumugENU3J/projectcss
import projectcss from "./plasmic_astriusdraft.module.css"; // plasmic-import: ct9kVdatV78GHhK9QiJ54N/projectcss
import sty from "./PlasmicBillingSettings.module.css"; // plasmic-import: JUc6WlNS_gQ/css

createPlasmicElementProxy;

export const PlasmicBillingSettings__VariantProps = new Array();

export const PlasmicBillingSettings__ArgProps = new Array(
  "bankName",
  "currentPlan",
  "accountingSoftware"
);

const $$ = {};

function PlasmicBillingSettings__RenderFunc(props) {
  const { variants, overrides, forNode } = props;
  const args = React.useMemo(() => Object.assign({}, props.args), [props.args]);
  const $props = {
    ...args,
    ...variants
  };
  const $ctx = ph.useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;
  const currentUser = p.useCurrentUser?.() || {};
  const stateSpecs = React.useMemo(
    () => [
      {
        path: "freeCheck.isChecked",
        type: "private",
        variableType: "boolean",
        initFunc: ({ $props, $state, $queries, $ctx }) => undefined
      },
      {
        path: "customCheck.isChecked",
        type: "private",
        variableType: "boolean",
        initFunc: ({ $props, $state, $queries, $ctx }) => undefined
      },
      {
        path: "premiumCheck.isChecked",
        type: "private",
        variableType: "boolean",
        initFunc: ({ $props, $state, $queries, $ctx }) => undefined
      },
      {
        path: "growthCheck.isChecked",
        type: "private",
        variableType: "boolean",
        initFunc: ({ $props, $state, $queries, $ctx }) => undefined
      }
    ],

    [$props, $ctx, $refs]
  );
  const $state = p.useDollarState(stateSpecs, {
    $props,
    $ctx,
    $queries: {},
    $refs
  });
  return (
    <React.Fragment>
      <div className={projectcss.plasmic_page_wrapper}>
        <div
          data-plasmic-name={"root"}
          data-plasmic-override={overrides.root}
          data-plasmic-root={true}
          data-plasmic-for-node={forNode}
          className={classNames(
            projectcss.all,
            projectcss.root_reset,
            projectcss.plasmic_default_styles,
            projectcss.plasmic_mixins,
            projectcss.plasmic_tokens,
            plasmic_antd_5_hostless_css.plasmic_tokens,
            sty.root
          )}
        >
          <Sidebar
            data-plasmic-name={"sidebar"}
            data-plasmic-override={overrides.sidebar}
            className={classNames("__wab_instance", sty.sidebar)}
          />

          <div
            data-plasmic-name={"rectangle34"}
            data-plasmic-override={overrides.rectangle34}
            className={classNames(projectcss.all, sty.rectangle34)}
          >
            <p.Stack
              as={"div"}
              data-plasmic-name={"figmaPaste"}
              data-plasmic-override={overrides.figmaPaste}
              hasGap={true}
              className={classNames(projectcss.all, sty.figmaPaste)}
            >
              <div
                data-plasmic-name={"title22"}
                data-plasmic-override={overrides.title22}
                className={classNames(
                  projectcss.all,
                  projectcss.__wab_text,
                  sty.title22
                )}
              >
                {"Settings"}
              </div>
              <FinancialDetails
                data-plasmic-name={"financialDetails"}
                data-plasmic-override={overrides.financialDetails}
                className={classNames("__wab_instance", sty.financialDetails)}
              />

              <UserManagement
                data-plasmic-name={"userManagement"}
                data-plasmic-override={overrides.userManagement}
                className={classNames("__wab_instance", sty.userManagement)}
              />

              <Branding
                data-plasmic-name={"branding"}
                data-plasmic-override={overrides.branding}
                className={classNames("__wab_instance", sty.branding)}
              />
            </p.Stack>
          </div>
          <p.Stack
            as={"div"}
            data-plasmic-name={"vertStack"}
            data-plasmic-override={overrides.vertStack}
            hasGap={true}
            className={classNames(projectcss.all, sty.vertStack)}
          >
            <p.Stack
              as={"div"}
              data-plasmic-name={"billingDetail"}
              data-plasmic-override={overrides.billingDetail}
              hasGap={true}
              className={classNames(projectcss.all, sty.billingDetail)}
            >
              <div className={classNames(projectcss.all, sty.freeBox__lusYv)}>
                <div
                  data-plasmic-name={"title9"}
                  data-plasmic-override={overrides.title9}
                  className={classNames(
                    projectcss.all,
                    projectcss.__wab_text,
                    sty.title9
                  )}
                >
                  {"Billing Details"}
                </div>
              </div>
              <div
                data-plasmic-name={"switchPlanStack"}
                data-plasmic-override={overrides.switchPlanStack}
                className={classNames(projectcss.all, sty.switchPlanStack)}
              >
                <div className={classNames(projectcss.all, sty.freeBox__zbLau)}>
                  <div
                    data-plasmic-name={"title10"}
                    data-plasmic-override={overrides.title10}
                    className={classNames(
                      projectcss.all,
                      projectcss.__wab_text,
                      sty.title10
                    )}
                  >
                    {"Payment Plan:"}
                  </div>
                  <div
                    className={classNames(projectcss.all, sty.freeBox__jm6NM)}
                  >
                    {p.renderPlasmicSlot({
                      defaultContents: (
                        <div
                          className={classNames(
                            projectcss.all,
                            projectcss.__wab_text,
                            sty.text__lj6Mq
                          )}
                        >
                          {"Growth"}
                        </div>
                      ),

                      value: args.currentPlan,
                      className: classNames(sty.slotTargetCurrentPlan)
                    })}
                  </div>
                </div>
                <div
                  data-plasmic-name={"switchPlan"}
                  data-plasmic-override={overrides.switchPlan}
                  className={classNames(projectcss.all, sty.switchPlan)}
                >
                  <div
                    className={classNames(
                      projectcss.all,
                      projectcss.__wab_text,
                      sty.text__p04H1
                    )}
                  >
                    {"Switch Plan"}
                  </div>
                </div>
              </div>
              <p.Stack
                as={"div"}
                data-plasmic-name={"planStack"}
                data-plasmic-override={overrides.planStack}
                hasGap={true}
                className={classNames(projectcss.all, sty.planStack)}
              >
                <div className={classNames(projectcss.all, sty.freeBox__va4B1)}>
                  <div
                    data-plasmic-name={"title17"}
                    data-plasmic-override={overrides.title17}
                    className={classNames(
                      projectcss.all,
                      projectcss.__wab_text,
                      sty.title17
                    )}
                  >
                    {" New Payment Plan:"}
                  </div>
                  <div
                    data-plasmic-name={"closeButton"}
                    data-plasmic-override={overrides.closeButton}
                    className={classNames(
                      projectcss.all,
                      projectcss.__wab_text,
                      sty.closeButton
                    )}
                  >
                    {"X"}
                  </div>
                </div>
                <div
                  data-plasmic-name={"freeStack"}
                  data-plasmic-override={overrides.freeStack}
                  className={classNames(projectcss.all, sty.freeStack)}
                >
                  <Checkbox3
                    data-plasmic-name={"freeCheck"}
                    data-plasmic-override={overrides.freeCheck}
                    className={classNames("__wab_instance", sty.freeCheck)}
                    isChecked={
                      p.generateStateValueProp($state, [
                        "freeCheck",
                        "isChecked"
                      ]) ?? false
                    }
                    onChange={(...eventArgs) => {
                      p.generateStateOnChangeProp($state, [
                        "freeCheck",
                        "isChecked"
                      ])(eventArgs[0]);
                    }}
                  />

                  <div
                    data-plasmic-name={"title18"}
                    data-plasmic-override={overrides.title18}
                    className={classNames(
                      projectcss.all,
                      projectcss.__wab_text,
                      sty.title18
                    )}
                  >
                    {"Free Plan ($0/month) - Unlimited Transaction Volume "}
                  </div>
                </div>
                <div
                  data-plasmic-name={"premiumStack"}
                  data-plasmic-override={overrides.premiumStack}
                  className={classNames(projectcss.all, sty.premiumStack)}
                >
                  <Checkbox3
                    data-plasmic-name={"premiumCheck"}
                    data-plasmic-override={overrides.premiumCheck}
                    className={classNames("__wab_instance", sty.premiumCheck)}
                    isChecked={
                      p.generateStateValueProp($state, [
                        "premiumCheck",
                        "isChecked"
                      ]) ?? false
                    }
                    onChange={(...eventArgs) => {
                      p.generateStateOnChangeProp($state, [
                        "premiumCheck",
                        "isChecked"
                      ])(eventArgs[0]);
                    }}
                  />

                  <div
                    data-plasmic-name={"title15"}
                    data-plasmic-override={overrides.title15}
                    className={classNames(
                      projectcss.all,
                      projectcss.__wab_text,
                      sty.title15
                    )}
                  >
                    {"Premium Plan ($49/month) - Up to $12,000/month"}
                  </div>
                </div>
                <div
                  data-plasmic-name={"growthStack"}
                  data-plasmic-override={overrides.growthStack}
                  className={classNames(projectcss.all, sty.growthStack)}
                >
                  <Checkbox3
                    data-plasmic-name={"growthCheck"}
                    data-plasmic-override={overrides.growthCheck}
                    className={classNames("__wab_instance", sty.growthCheck)}
                    isChecked={
                      p.generateStateValueProp($state, [
                        "growthCheck",
                        "isChecked"
                      ]) ?? false
                    }
                    onChange={(...eventArgs) => {
                      p.generateStateOnChangeProp($state, [
                        "growthCheck",
                        "isChecked"
                      ])(eventArgs[0]);
                    }}
                  />

                  <div
                    data-plasmic-name={"title16"}
                    data-plasmic-override={overrides.title16}
                    className={classNames(
                      projectcss.all,
                      projectcss.__wab_text,
                      sty.title16
                    )}
                  >
                    {"Growth Plan ($89/month) - Up to $50,000/month"}
                  </div>
                </div>
                <div
                  data-plasmic-name={"customStack"}
                  data-plasmic-override={overrides.customStack}
                  className={classNames(projectcss.all, sty.customStack)}
                >
                  <Checkbox3
                    data-plasmic-name={"customCheck"}
                    data-plasmic-override={overrides.customCheck}
                    className={classNames("__wab_instance", sty.customCheck)}
                    isChecked={
                      p.generateStateValueProp($state, [
                        "customCheck",
                        "isChecked"
                      ]) ?? false
                    }
                    onChange={(...eventArgs) => {
                      p.generateStateOnChangeProp($state, [
                        "customCheck",
                        "isChecked"
                      ])(eventArgs[0]);
                    }}
                  />

                  <div
                    data-plasmic-name={"title12"}
                    data-plasmic-override={overrides.title12}
                    className={classNames(
                      projectcss.all,
                      projectcss.__wab_text,
                      sty.title12
                    )}
                  >
                    {"Custom Plan - Custom Processing Limit"}
                  </div>
                </div>
                <div
                  data-plasmic-name={"finalizePlan"}
                  data-plasmic-override={overrides.finalizePlan}
                  className={classNames(projectcss.all, sty.finalizePlan)}
                >
                  <div
                    className={classNames(
                      projectcss.all,
                      projectcss.__wab_text,
                      sty.text__p9Shk
                    )}
                  >
                    {"Finalize Plan"}
                  </div>
                </div>
              </p.Stack>
              <div
                className={classNames(
                  projectcss.all,
                  projectcss.__wab_text,
                  sty.text__k2Si3
                )}
              >
                <React.Fragment>
                  <React.Fragment>
                    {"More information on our payment plans can be found "}
                  </React.Fragment>
                  {
                    <a
                      data-plasmic-name={"link"}
                      data-plasmic-override={overrides.link}
                      className={classNames(
                        projectcss.all,
                        projectcss.a,
                        projectcss.__wab_text,
                        projectcss.plasmic_default__inline,
                        sty.link
                      )}
                      href={"https://astrius.co/pricing"}
                      target={"_blank"}
                    >
                      <React.Fragment>
                        <span
                          className={
                            "plasmic_default__all plasmic_default__span"
                          }
                          style={{ color: "#3555FF" }}
                        >
                          {"here"}
                        </span>
                      </React.Fragment>
                    </a>
                  }

                  <React.Fragment>{""}</React.Fragment>
                </React.Fragment>
              </div>
              <div className={classNames(projectcss.all, sty.freeBox___23OHf)}>
                <div className={classNames(projectcss.all, sty.freeBox__guYlL)}>
                  <div
                    data-plasmic-name={"title13"}
                    data-plasmic-override={overrides.title13}
                    className={classNames(
                      projectcss.all,
                      projectcss.__wab_text,
                      sty.title13
                    )}
                  >
                    {"Bank Account:"}
                  </div>
                  <div
                    className={classNames(projectcss.all, sty.freeBox__zbFXq)}
                  >
                    {p.renderPlasmicSlot({
                      defaultContents: (
                        <div
                          className={classNames(
                            projectcss.all,
                            projectcss.__wab_text,
                            sty.text__rvMy8
                          )}
                        >
                          {"Plaid Checking"}
                        </div>
                      ),

                      value: args.bankName,
                      className: classNames(sty.slotTargetBankName)
                    })}
                  </div>
                </div>
                <div
                  data-plasmic-name={"switchBank"}
                  data-plasmic-override={overrides.switchBank}
                  className={classNames(projectcss.all, sty.switchBank)}
                >
                  <div
                    className={classNames(
                      projectcss.all,
                      projectcss.__wab_text,
                      sty.text___3JW3Q
                    )}
                  >
                    {"Switch Bank"}
                  </div>
                </div>
              </div>
              <div
                className={classNames(
                  projectcss.all,
                  projectcss.__wab_text,
                  sty.text__pAzJ
                )}
              >
                {
                  "Please note, this bank account will be used for both payouts and payment charges "
                }
              </div>
            </p.Stack>
            <p.Stack
              as={"div"}
              data-plasmic-name={"accountingSoftwareStack"}
              data-plasmic-override={overrides.accountingSoftwareStack}
              hasGap={true}
              className={classNames(
                projectcss.all,
                sty.accountingSoftwareStack
              )}
            >
              <div className={classNames(projectcss.all, sty.freeBox__nqEj)}>
                <div
                  data-plasmic-name={"title19"}
                  data-plasmic-override={overrides.title19}
                  className={classNames(
                    projectcss.all,
                    projectcss.__wab_text,
                    sty.title19
                  )}
                >
                  {"Accounting Software"}
                </div>
              </div>
              <div
                data-plasmic-name={"switchPlanStack2"}
                data-plasmic-override={overrides.switchPlanStack2}
                className={classNames(projectcss.all, sty.switchPlanStack2)}
              >
                <div
                  className={classNames(projectcss.all, sty.freeBox___2Vokv)}
                >
                  <div
                    data-plasmic-name={"title20"}
                    data-plasmic-override={overrides.title20}
                    className={classNames(
                      projectcss.all,
                      projectcss.__wab_text,
                      sty.title20
                    )}
                  >
                    {"Current Software:"}
                  </div>
                  <div
                    className={classNames(projectcss.all, sty.freeBox___2Fo6E)}
                  >
                    {p.renderPlasmicSlot({
                      defaultContents: (
                        <div
                          className={classNames(
                            projectcss.all,
                            projectcss.__wab_text,
                            sty.text__j7RVv
                          )}
                        >
                          {"Not Linked"}
                        </div>
                      ),

                      value: args.accountingSoftware,
                      className: classNames(sty.slotTargetAccountingSoftware)
                    })}
                  </div>
                </div>
                <div
                  data-plasmic-name={"linkAccount"}
                  data-plasmic-override={overrides.linkAccount}
                  className={classNames(projectcss.all, sty.linkAccount)}
                >
                  <div
                    className={classNames(
                      projectcss.all,
                      projectcss.__wab_text,
                      sty.text__iGO4
                    )}
                  >
                    {"Link Account"}
                  </div>
                </div>
              </div>
            </p.Stack>
            <div
              data-plasmic-name={"inviteUsersStack"}
              data-plasmic-override={overrides.inviteUsersStack}
              className={classNames(projectcss.all, sty.inviteUsersStack)}
            >
              <div className={classNames(projectcss.all, sty.freeBox__yCn3R)}>
                <div
                  className={classNames(
                    projectcss.all,
                    projectcss.__wab_text,
                    sty.text___0Nj
                  )}
                >
                  <React.Fragment>
                    <React.Fragment>{""}</React.Fragment>
                    {
                      <h4
                        data-plasmic-name={"inviteUsersHeading"}
                        data-plasmic-override={overrides.inviteUsersHeading}
                        className={classNames(
                          projectcss.all,
                          projectcss.h4,
                          projectcss.__wab_text,
                          sty.inviteUsersHeading
                        )}
                      >
                        {"Invite Users"}
                      </h4>
                    }

                    <React.Fragment>{""}</React.Fragment>
                  </React.Fragment>
                </div>
              </div>
              <div className={classNames(projectcss.all, sty.freeBox__jbMp0)}>
                <div
                  data-plasmic-name={"inviteUsersBtn"}
                  data-plasmic-override={overrides.inviteUsersBtn}
                  className={classNames(projectcss.all, sty.inviteUsersBtn)}
                >
                  <div
                    className={classNames(
                      projectcss.all,
                      projectcss.__wab_text,
                      sty.text__kmR9
                    )}
                  >
                    {"Invite User"}
                  </div>
                </div>
                <div
                  className={classNames(
                    projectcss.all,
                    projectcss.__wab_text,
                    sty.text__padi
                  )}
                >
                  <React.Fragment>
                    <React.Fragment>{""}</React.Fragment>
                    {
                      <h6
                        className={classNames(
                          projectcss.all,
                          projectcss.h6,
                          projectcss.__wab_text,
                          sty.h6__abxFl
                        )}
                      >
                        {"User List:"}
                      </h6>
                    }

                    <React.Fragment>{""}</React.Fragment>
                  </React.Fragment>
                </div>
              </div>
              <div className={classNames(projectcss.all, sty.freeBox__nlBeh)}>
                <div
                  data-plasmic-name={"userListStack"}
                  data-plasmic-override={overrides.userListStack}
                  className={classNames(projectcss.all, sty.userListStack)}
                >
                  <InviteUserCard
                    className={classNames(
                      "__wab_instance",
                      sty.inviteUserCard___5SXH
                    )}
                    userName={
                      <div
                        className={classNames(
                          projectcss.all,
                          projectcss.__wab_text,
                          sty.text__ylfiT
                        )}
                      >
                        {"joedoe@gmail.com"}
                      </div>
                    }
                  />
                </div>
              </div>
            </div>
            <div
              data-plasmic-name={"brandingStack"}
              data-plasmic-override={overrides.brandingStack}
              className={classNames(projectcss.all, sty.brandingStack)}
            >
              <div className={classNames(projectcss.all, sty.freeBox__neARd)}>
                <div
                  className={classNames(
                    projectcss.all,
                    projectcss.__wab_text,
                    sty.text___8DpMo
                  )}
                >
                  <React.Fragment>
                    <React.Fragment>{""}</React.Fragment>
                    {
                      <h4
                        data-plasmic-name={"inviteUsersHeading2"}
                        data-plasmic-override={overrides.inviteUsersHeading2}
                        className={classNames(
                          projectcss.all,
                          projectcss.h4,
                          projectcss.__wab_text,
                          sty.inviteUsersHeading2
                        )}
                      >
                        {"Company Logo & Color"}
                      </h4>
                    }

                    <React.Fragment>{""}</React.Fragment>
                  </React.Fragment>
                </div>
              </div>
              <div className={classNames(projectcss.all, sty.freeBox__f4Yaa)}>
                <p.PlasmicImg
                  data-plasmic-name={"logo"}
                  data-plasmic-override={overrides.logo}
                  alt={""}
                  className={classNames(sty.logo)}
                  displayHeight={"54px"}
                  displayMaxHeight={"none"}
                  displayMaxWidth={"100%"}
                  displayMinHeight={"0"}
                  displayMinWidth={"0"}
                  displayWidth={"auto"}
                  loading={"lazy"}
                />

                <div
                  className={classNames(
                    projectcss.all,
                    projectcss.__wab_text,
                    sty.text__f73Aw
                  )}
                >
                  <React.Fragment>
                    <React.Fragment>{""}</React.Fragment>
                    {
                      <h6
                        className={classNames(
                          projectcss.all,
                          projectcss.h6,
                          projectcss.__wab_text,
                          sty.h6__k2AT6
                        )}
                      >
                        {"Logo:"}
                      </h6>
                    }

                    <React.Fragment>{""}</React.Fragment>
                  </React.Fragment>
                </div>
              </div>
              <div className={classNames(projectcss.all, sty.freeBox__kDlu3)}>
                <div
                  data-plasmic-name={"colorPickerContainer"}
                  data-plasmic-override={overrides.colorPickerContainer}
                  className={classNames(
                    projectcss.all,
                    sty.colorPickerContainer
                  )}
                >
                  <InviteUserCard
                    className={classNames(
                      "__wab_instance",
                      sty.inviteUserCard__mc2BP
                    )}
                    userName={
                      <div
                        className={classNames(
                          projectcss.all,
                          projectcss.__wab_text,
                          sty.text__mgdY4
                        )}
                      >
                        {"Button Color Picker:"}
                      </div>
                    }
                  />
                </div>
              </div>
              <div className={classNames(projectcss.all, sty.freeBox__lEf9F)}>
                <div
                  data-plasmic-name={"saveStack"}
                  data-plasmic-override={overrides.saveStack}
                  className={classNames(projectcss.all, sty.saveStack)}
                >
                  <Button
                    data-plasmic-name={"handleSubmit"}
                    data-plasmic-override={overrides.handleSubmit}
                    className={classNames("__wab_instance", sty.handleSubmit)}
                  >
                    {"Save"}
                  </Button>
                </div>
              </div>
            </div>
          </p.Stack>
        </div>
      </div>
    </React.Fragment>
  );
}

const PlasmicDescendants = {
  root: [
    "root",
    "sidebar",
    "rectangle34",
    "figmaPaste",
    "title22",
    "financialDetails",
    "userManagement",
    "branding",
    "vertStack",
    "billingDetail",
    "title9",
    "switchPlanStack",
    "title10",
    "switchPlan",
    "planStack",
    "title17",
    "closeButton",
    "freeStack",
    "freeCheck",
    "title18",
    "premiumStack",
    "premiumCheck",
    "title15",
    "growthStack",
    "growthCheck",
    "title16",
    "customStack",
    "customCheck",
    "title12",
    "finalizePlan",
    "link",
    "title13",
    "switchBank",
    "accountingSoftwareStack",
    "title19",
    "switchPlanStack2",
    "title20",
    "linkAccount",
    "inviteUsersStack",
    "inviteUsersHeading",
    "inviteUsersBtn",
    "userListStack",
    "brandingStack",
    "inviteUsersHeading2",
    "logo",
    "colorPickerContainer",
    "saveStack",
    "handleSubmit"
  ],

  sidebar: ["sidebar"],
  rectangle34: [
    "rectangle34",
    "figmaPaste",
    "title22",
    "financialDetails",
    "userManagement",
    "branding"
  ],

  figmaPaste: [
    "figmaPaste",
    "title22",
    "financialDetails",
    "userManagement",
    "branding"
  ],

  title22: ["title22"],
  financialDetails: ["financialDetails"],
  userManagement: ["userManagement"],
  branding: ["branding"],
  vertStack: [
    "vertStack",
    "billingDetail",
    "title9",
    "switchPlanStack",
    "title10",
    "switchPlan",
    "planStack",
    "title17",
    "closeButton",
    "freeStack",
    "freeCheck",
    "title18",
    "premiumStack",
    "premiumCheck",
    "title15",
    "growthStack",
    "growthCheck",
    "title16",
    "customStack",
    "customCheck",
    "title12",
    "finalizePlan",
    "link",
    "title13",
    "switchBank",
    "accountingSoftwareStack",
    "title19",
    "switchPlanStack2",
    "title20",
    "linkAccount",
    "inviteUsersStack",
    "inviteUsersHeading",
    "inviteUsersBtn",
    "userListStack",
    "brandingStack",
    "inviteUsersHeading2",
    "logo",
    "colorPickerContainer",
    "saveStack",
    "handleSubmit"
  ],

  billingDetail: [
    "billingDetail",
    "title9",
    "switchPlanStack",
    "title10",
    "switchPlan",
    "planStack",
    "title17",
    "closeButton",
    "freeStack",
    "freeCheck",
    "title18",
    "premiumStack",
    "premiumCheck",
    "title15",
    "growthStack",
    "growthCheck",
    "title16",
    "customStack",
    "customCheck",
    "title12",
    "finalizePlan",
    "link",
    "title13",
    "switchBank"
  ],

  title9: ["title9"],
  switchPlanStack: ["switchPlanStack", "title10", "switchPlan"],
  title10: ["title10"],
  switchPlan: ["switchPlan"],
  planStack: [
    "planStack",
    "title17",
    "closeButton",
    "freeStack",
    "freeCheck",
    "title18",
    "premiumStack",
    "premiumCheck",
    "title15",
    "growthStack",
    "growthCheck",
    "title16",
    "customStack",
    "customCheck",
    "title12",
    "finalizePlan"
  ],

  title17: ["title17"],
  closeButton: ["closeButton"],
  freeStack: ["freeStack", "freeCheck", "title18"],
  freeCheck: ["freeCheck"],
  title18: ["title18"],
  premiumStack: ["premiumStack", "premiumCheck", "title15"],
  premiumCheck: ["premiumCheck"],
  title15: ["title15"],
  growthStack: ["growthStack", "growthCheck", "title16"],
  growthCheck: ["growthCheck"],
  title16: ["title16"],
  customStack: ["customStack", "customCheck", "title12"],
  customCheck: ["customCheck"],
  title12: ["title12"],
  finalizePlan: ["finalizePlan"],
  link: ["link"],
  title13: ["title13"],
  switchBank: ["switchBank"],
  accountingSoftwareStack: [
    "accountingSoftwareStack",
    "title19",
    "switchPlanStack2",
    "title20",
    "linkAccount"
  ],

  title19: ["title19"],
  switchPlanStack2: ["switchPlanStack2", "title20", "linkAccount"],
  title20: ["title20"],
  linkAccount: ["linkAccount"],
  inviteUsersStack: [
    "inviteUsersStack",
    "inviteUsersHeading",
    "inviteUsersBtn",
    "userListStack"
  ],

  inviteUsersHeading: ["inviteUsersHeading"],
  inviteUsersBtn: ["inviteUsersBtn"],
  userListStack: ["userListStack"],
  brandingStack: [
    "brandingStack",
    "inviteUsersHeading2",
    "logo",
    "colorPickerContainer",
    "saveStack",
    "handleSubmit"
  ],

  inviteUsersHeading2: ["inviteUsersHeading2"],
  logo: ["logo"],
  colorPickerContainer: ["colorPickerContainer"],
  saveStack: ["saveStack", "handleSubmit"],
  handleSubmit: ["handleSubmit"]
};

function makeNodeComponent(nodeName) {
  const func = function (props) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicBillingSettings__ArgProps,
          internalVariantPropNames: PlasmicBillingSettings__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicBillingSettings__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "root") {
    func.displayName = "PlasmicBillingSettings";
  } else {
    func.displayName = `PlasmicBillingSettings.${nodeName}`;
  }
  return func;
}

export const PlasmicBillingSettings = Object.assign(
  // Top-level PlasmicBillingSettings renders the root element
  makeNodeComponent("root"),
  {
    // Helper components rendering sub-elements
    sidebar: makeNodeComponent("sidebar"),
    rectangle34: makeNodeComponent("rectangle34"),
    figmaPaste: makeNodeComponent("figmaPaste"),
    title22: makeNodeComponent("title22"),
    financialDetails: makeNodeComponent("financialDetails"),
    userManagement: makeNodeComponent("userManagement"),
    branding: makeNodeComponent("branding"),
    vertStack: makeNodeComponent("vertStack"),
    billingDetail: makeNodeComponent("billingDetail"),
    title9: makeNodeComponent("title9"),
    switchPlanStack: makeNodeComponent("switchPlanStack"),
    title10: makeNodeComponent("title10"),
    switchPlan: makeNodeComponent("switchPlan"),
    planStack: makeNodeComponent("planStack"),
    title17: makeNodeComponent("title17"),
    closeButton: makeNodeComponent("closeButton"),
    freeStack: makeNodeComponent("freeStack"),
    freeCheck: makeNodeComponent("freeCheck"),
    title18: makeNodeComponent("title18"),
    premiumStack: makeNodeComponent("premiumStack"),
    premiumCheck: makeNodeComponent("premiumCheck"),
    title15: makeNodeComponent("title15"),
    growthStack: makeNodeComponent("growthStack"),
    growthCheck: makeNodeComponent("growthCheck"),
    title16: makeNodeComponent("title16"),
    customStack: makeNodeComponent("customStack"),
    customCheck: makeNodeComponent("customCheck"),
    title12: makeNodeComponent("title12"),
    finalizePlan: makeNodeComponent("finalizePlan"),
    link: makeNodeComponent("link"),
    title13: makeNodeComponent("title13"),
    switchBank: makeNodeComponent("switchBank"),
    accountingSoftwareStack: makeNodeComponent("accountingSoftwareStack"),
    title19: makeNodeComponent("title19"),
    switchPlanStack2: makeNodeComponent("switchPlanStack2"),
    title20: makeNodeComponent("title20"),
    linkAccount: makeNodeComponent("linkAccount"),
    inviteUsersStack: makeNodeComponent("inviteUsersStack"),
    inviteUsersHeading: makeNodeComponent("inviteUsersHeading"),
    inviteUsersBtn: makeNodeComponent("inviteUsersBtn"),
    userListStack: makeNodeComponent("userListStack"),
    brandingStack: makeNodeComponent("brandingStack"),
    inviteUsersHeading2: makeNodeComponent("inviteUsersHeading2"),
    logo: makeNodeComponent("logo"),
    colorPickerContainer: makeNodeComponent("colorPickerContainer"),
    saveStack: makeNodeComponent("saveStack"),
    handleSubmit: makeNodeComponent("handleSubmit"),
    // Metadata about props expected for PlasmicBillingSettings
    internalVariantProps: PlasmicBillingSettings__VariantProps,
    internalArgProps: PlasmicBillingSettings__ArgProps,
    // Page metadata
    pageMetadata: {
      title: "",
      description: "",
      ogImageSrc: "",
      canonical: ""
    }
  }
);

export default PlasmicBillingSettings;
/* prettier-ignore-end */
